import { BookLocation } from 'types';

/**
 * @method getNextLocationFromCurrentPercentage
 */
const getNextLocationFromCurrentPercentage = (
  nextPercentage,
  document,
  currentPercentage,
) => {
  let nextBookLocation;

  if (nextPercentage <= 1 && currentPercentage < nextPercentage) {
    nextBookLocation = new BookLocation({
      document,
      percentageOfDocument: nextPercentage,
    });
  } else if (
    currentPercentage === 1 ||
    (currentPercentage === 1 && nextPercentage === 1)
  ) {
    // will be undefined when there is no document.next aka at the end of the book
    // this is expected, scrub bar navigation disables the arrow button in this case
    nextBookLocation = document.next?.bookLocation;
  }
  return nextBookLocation;
};

export default getNextLocationFromCurrentPercentage;
